// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.clusterIcon {\n  border: none;\n}\n.logo {\n  max-height: 40px;\n  opacity: 0.8;\n}\n.logo-control {\n  padding-bottom: 0px;\n  text-align: end;\n  margin-bottom: 0px !important;\n  margin-right: 4px !important;\n}\n.heatmap-control {\n  margin-bottom: 4px !important;\n}\n.leaflet-control-layers-expanded {\n  z-index: 2000;\n}\n.leaflet-bottom {\n  z-index: 500;\n}\n.leaflet-control-layers {\n  border: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
